import { Skeleton } from "@/components/ui/skeleton";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { usePrehladPrace } from "@/api/hooks/usePraca";
import { formatTrvanie } from "@/lib/useHeartbeat";

/**
 * Odpracovaný čas na zákazkách — meria sa pulzom z otvoreného editora.
 *
 * Do KOLA 69 to bol tab v Histórii. História je pre všetkých, ale toto je
 * údaj o ľuďoch, nie o zákazke — patrí za admin guard (`/api/praca`).
 */
export function PracaSection(): JSX.Element {
  const query = usePrehladPrace();
  const polozky = query.data?.data ?? [];

  return (
    <section className="space-y-3 rounded-lg border bg-card p-4">
      <div>
        <h2 className="text-xl">Odpracovaný čas na zákazkách</h2>
        <p className="text-xs text-muted-foreground">
          Meria sa, kým je zákazka otvorená a niekto pri nej pracuje.
          Neaktivita nad 3 minúty sa nepočíta, takže otvorená karta cez obed
          čas nenaťahuje.
        </p>
      </div>

      {query.isLoading ? (
        <Skeleton className="h-24 w-full" />
      ) : polozky.length === 0 ? (
        <p className="py-4 text-center text-sm text-muted-foreground">
          Zatiaľ sa nemeria žiadny čas — meranie začne, keď niekto otvorí
          zákazku.
        </p>
      ) : (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Zákazka</TableHead>
              <TableHead className="text-right">Celkom</TableHead>
              <TableHead>Po ľuďoch</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {polozky.map((p) => (
              <TableRow key={p.zakazka_id}>
                <TableCell className="text-sm">
                  <span className="font-mono">{p.cislo_zakazky}</span>
                  {p.nazov ? (
                    <span className="ml-2 text-muted-foreground">
                      {p.nazov}
                    </span>
                  ) : null}
                </TableCell>
                <TableCell className="text-right font-mono text-sm">
                  {formatTrvanie(p.sekundy_celkom)}
                </TableCell>
                <TableCell className="text-xs text-muted-foreground">
                  {p.podla_autora
                    .map((a) => `${a.autor} ${formatTrvanie(a.sekundy)}`)
                    .join(" · ")}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </section>
  );
}
